import React, { useState, useEffect } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, TablePagination, Button } from '@mui/material';
import isGHMC from '../../../Common/helper/helpar';
import { useLocation, useNavigate } from 'react-router-dom';
import ExcelJS from "exceljs";
import { AllInnerReportDeployedJN } from '../../../Apis/userCreationApi';
import { TableLoader } from '../../../Common/ShimmerLoader';

const InnerReportDeployedJN = () => {
    const navigate = useNavigate()
  const location = useLocation();
  const [rows, setRows] = useState([]);
  const [filteredRows, setFilteredRows] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(100);
  const [page, setPage] = useState(0);
  const [dataLoading, setDataLoading] = useState(true);
  const isProd = isGHMC();
  const data1 = location.state;

  // Fetch data from the API
  const fetchInnerReportData = async () => {
    setDataLoading(true);
    try {
      const fromDate = data1.fromDate; // Current date start time
      const toDate = data1.toDate;     // Current date end time
      const data = await AllInnerReportDeployedJN(
        data1.transferStationId,
        fromDate,
        toDate,
        data1.shiftId
      );
      setRows(data);
      setFilteredRows(data);
      setDataLoading(false);
    } catch (error) {
      console.error('Error fetching inner report data:', error);
      setDataLoading(false);
    }
  };

  // Call fetchInnerReportData when the component mounts
  useEffect(() => {
    if (data1) {
      fetchInnerReportData(data1);
    }
  }, [data1]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 100));
    setPage(0); // Reset to first page when rows per page changes
  };

  const shiftMapping = {
    '1': 'Morning',
    '2': 'Afternoon',
    '3': 'Evening',
  };

  // Calculate the index range for the current page
  const startIndex = page * rowsPerPage;
  const endIndex = startIndex + rowsPerPage;
  const currentRows = filteredRows.slice(startIndex, endIndex);


  const downloadAsExcel = async () => {
    // Determine if the data is sorted or not
    
    // Create a new workbook and add a worksheet
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Teritary Deployment TS Report");

    // Define styles
    const boldFont = { bold: true };

    // Get current date and time
    const currentDate = new Date();
    const formattedDate = `${currentDate.getDate()}-${currentDate.getMonth() + 1}-${currentDate.getFullYear()}`;
    const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
    const downloadDateTime = `Teritary Deployment TS/SCTP Report Generated on: ${formattedDate}, ${formattedTime}`;

    // Add the downloadDateTime to the worksheet
    worksheet.addRow(["", "", downloadDateTime, ""]);
    worksheet.mergeCells(1, 2, 1, 6);
    worksheet.getCell(1, 2).value = downloadDateTime;
    worksheet.getCell(1, 2).font = boldFont;
    worksheet.getCell(1, 2).alignment = { horizontal: "center" };

    // Add "Zone Details" header
    worksheet.addRow(["", "", "Teritary Deployment TS report", ""]);
    worksheet.mergeCells(2, 2, 2, 6);
    worksheet.getCell(2, 2).value = "Teritary Deployment TS report";
    worksheet.getCell(2, 2).font = boldFont;
    worksheet.getCell(2, 2).alignment = { horizontal: "center" };

    // Define table headers
    const tableHeaderRow = worksheet.addRow([
      "S.No",
     "Vehicle Number",
     "Driver Name",
      "Source Location",
      "Destination Location",
     " Operation Type",
     " Shift",
      "Deployment Time",
      "Vehicle Type",
      "Owner Type",
      "Vehicle Capacity"
    ]);
    tableHeaderRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      cell.font = boldFont;
      cell.alignment = { horizontal: "left" };
      if (colNumber >= 1 && colNumber <= 17) {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "F6B1B1" }, // Background color
          bgColor: { argb: "FFFFFFFF" } // Text color
        };
      }
    });

    // Add data rows
    rows.forEach((item, index) => {
      worksheet.addRow([
        index + 1,
        item.vehicleNumber?? "N/A",
        item.driverName?? "N/A",
        item.deploymentLocation?? "N/A",
        item.destinationLocation?? "N/A",
        item.operationType?? "N/A",
        item.shiftId?? "N/A",
        item.deploymentDateTime?? "N/A",
        item.vehicleTypeName?? "N/A",
        item.ownerTypeName?? "N/A",
        item.vehicleCapacity?? "N/A"
      ]).eachCell({ includeEmpty: true }, (cell, colNumber) => {
        cell.alignment = { horizontal: "left" };
      });
    });

    // Set column widths dynamically based on content
    worksheet.columns = [
      { width: 5 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
    ];

    // Save the workbook to a file
    try {
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "TeritaryTSReport.xlsx";
      a.click();
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error generating Excel file:", error);
    }
  };


  return (
    <div>
      <div style={{ width: "100%" }}>
        <div className="content">
          <div className="page-content">
            <div className="top-header page-title">
              <span>{" "}
                    Teritary Deployment JN Report</span>
            </div>
          <div className="page-header"></div>
            <div class="row" style={{ textAlign: "justify" }}>
            </div>
          <div className="card">
          <div className="card-body p-3">
          <div className="d-flex justify-content-end mt-3 mb-3">
            {/* <h4 className="text-start mb-3">Teritary Deployment JN Report</h4> */}
            <button
              variant="contained"
            //   color="error" // Red color
             className="btn btn-secondary"
              onClick={() => navigate(-1)} // Navigate back
              // sx={{ marginBottom: '20px',marginTop:'20px',backgroundColor:'red' }} // Add some margin for spacing
            >
              Back
            </button>
            <button className="btn btn-excel" 
                    onClick={downloadAsExcel}
                  >
                     <i class="fa-solid fa-file-excel me-1 icon-container"></i> Excel
                  </button>
            </div>
          
                {dataLoading ? <TableLoader height={500} /> : <Paper sx={{ width: '100%', overflow: 'hidden' }}>
                      <TableContainer
                        component={Paper}
                        sx={{
                          width: '100%',
                          maxHeight: '500px',
                          overflowY: 'auto',
                          boxShadow: '0px 3px 6px rgba(0,0,0,0.1)',
                          border: '1px solid #ccc',
                        }}
                      >
                        <Table sx={{ minWidth: 700, borderCollapse: 'collapse' }}>
                          <TableHead
                            className={`${isProd ? 'bg-ghmc' : 'bg-swm'}`}
                            sx={{
                              position: 'sticky',
                              top: 0,
                              zIndex: 1,
                            }}
                          >
                            <TableRow sx={{ paddingTop: '20px' }}>
                              <TableCell sx={{ textAlign: 'center',border: '1px solid #ddd', padding: '10px', color: '#fff', backgroundColor: isProd ? "#004554" : "#EC1117", }}>S.No</TableCell>
                              <TableCell sx={{ textAlign: 'center',border: '1px solid #ddd', padding: '10px', color: '#fff', backgroundColor: isProd ? "#004554" : "#EC1117", }}>Vehicle Number</TableCell>
                              <TableCell sx={{ textAlign: 'center', border: '1px solid #ddd',padding: '10px', color: '#fff', backgroundColor: isProd ? "#004554" : "#EC1117", }}>Driver Name</TableCell>
                              <TableCell sx={{ textAlign: 'center',border: '1px solid #ddd', padding: '10px', color: '#fff', backgroundColor: isProd ? "#004554" : "#EC1117", }}>Source Location</TableCell>
                              <TableCell sx={{ textAlign: 'center',border: '1px solid #ddd', padding: '10px', color: '#fff', backgroundColor: isProd ? "#004554" : "#EC1117", }}>Destination Location</TableCell>
                              <TableCell sx={{ textAlign: 'center',border: '1px solid #ddd', padding: '10px', color: '#fff', backgroundColor: isProd ? "#004554" : "#EC1117", }}>Operation Type</TableCell>
                              <TableCell sx={{ textAlign: 'center',border: '1px solid #ddd', padding: '10px', color: '#fff', backgroundColor: isProd ? "#004554" : "#EC1117", }}>Shift</TableCell>
                              <TableCell sx={{ textAlign: 'center',border: '1px solid #ddd', padding: '10px', color: '#fff', backgroundColor: isProd ? "#004554" : "#EC1117", }}>Deployment Time</TableCell>
                              <TableCell sx={{ textAlign: 'center',border: '1px solid #ddd', padding: '10px', color: '#fff', backgroundColor: isProd ? "#004554" : "#EC1117", }}>Vehicle Type</TableCell>
                              <TableCell sx={{ textAlign: 'center',border: '1px solid #ddd', padding: '10px', color: '#fff', backgroundColor: isProd ? "#004554" : "#EC1117", }}>Owner Type</TableCell>
                              <TableCell sx={{ textAlign: 'center',border: '1px solid #ddd', padding: '10px', color: '#fff', backgroundColor: isProd ? "#004554" : "#EC1117", }}>Vehicle Capacity</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {currentRows.length > 0 ? (
                              currentRows.map((row, index) => (
                                <TableRow
                                  key={row.sno}
                                  sx={{
                                    backgroundColor: index % 2 === 1 ? 'rgba(0, 69, 84, 0.04)' : '#ffffff',
                                  }}
                                >
                                  <TableCell sx={{ textAlign: 'center',border: '1px solid #ddd' }}>{startIndex + index + 1}</TableCell>
                                  <TableCell sx={{ textAlign: 'center' ,border: '1px solid #ddd'}}>{row.vehicleNumber || 'N/A'}</TableCell>
                                  <TableCell sx={{ textAlign: 'center' ,border: '1px solid #ddd',}}>{row.driverName || 'N/A'}</TableCell>
                                  <TableCell sx={{ textAlign: 'center' ,border: '1px solid #ddd',}}>{row.deploymentLocation || 'N/A'}</TableCell>
                                  <TableCell sx={{ textAlign: 'center',border: '1px solid #ddd', }}>{row.destinationLocation || 'N/A'}</TableCell>
                                  <TableCell sx={{ textAlign: 'center',border: '1px solid #ddd', }}>{row.operationType || 'N/A'}</TableCell>
                                  <TableCell sx={{ textAlign: 'center' ,border: '1px solid #ddd',}}>{shiftMapping[row.shiftId] || 'Unknown'}</TableCell>
                                  <TableCell sx={{ textAlign: 'center',border: '1px solid #ddd', }}>{row.deploymentDateTime || 'N/A'}</TableCell>
                                  <TableCell sx={{ textAlign: 'center',border: '1px solid #ddd', }}>{row.vehicleTypeName || 'N/A'}</TableCell>
                                  <TableCell sx={{ textAlign: 'center',border: '1px solid #ddd', }}>{row.ownerTypeName || 'N/A'}</TableCell>
                                  <TableCell sx={{ textAlign: 'center',border: '1px solid #ddd', }}>{row.vehicleCapacity || 'N/A'}</TableCell>
                                </TableRow>
                              ))
                            ) : (
                              <TableRow>
                                <TableCell colSpan={8} sx={{ textAlign: 'center' }}>No data available</TableCell>
                              </TableRow>
                            )}
                          </TableBody>
                        </Table>
                      </TableContainer>
                      <TablePagination
                        component="div"
                        count={filteredRows.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                      />
                    </Paper>}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
   
  );
};

export default InnerReportDeployedJN;
